import React, { type FC, memo } from "react";
import styles from "./Filter.module.scss";
import { useGradeSelectorDispatch, useGradeSelectorSelector } from "../../../../../redux/hooks";
import { GradeSelectorLabel } from "../../../../../utils/labels";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import { clearFilters } from "../../../../../redux/slices/GradeSelectorFiltersSlice";
import { getActiveFilterAmount } from "../../../../../utils/filterUtils";
import { trackResetFilters } from "../../../../../utils/tracking";
import { getCommonLabel } from "../../../../../../../../common-deprecated/utils/commonLabels";

const ActiveFilters: FC = () => {
    const dispatch = useGradeSelectorDispatch();

    const activeFilters = useGradeSelectorSelector((state) => state.gradeSelectorFilters.filters);
    const activeFilterAmount = getActiveFilterAmount(activeFilters);
    const commonSettings = useGradeSelectorSelector((state) => state.commonSettings);

    if (activeFilterAmount === 0) return null;

    return (
        <div className={styles["active-filters-wrapper"]}>
            <div className={styles["active-filters-content"]}>
                {activeFilterAmount === 1 ? (
                    <GradeSelectorLabel label="gradeSelectorActiveFilter" />
                ) : (
                    <GradeSelectorLabel
                        label="gradeSelectorActiveFilters"
                        params={{ amount: activeFilterAmount.toString() }}
                    />
                )}
                <Button
                    onClick={() => {
                        dispatch(clearFilters());
                        trackResetFilters();
                    }}
                    aria-label={getCommonLabel({ commonSettings }, "close")}
                    variant="clean"
                >
                    <GradeSelectorLabel label="gradeSelectorRemoveFilters" />
                    <Icon variant="close" sizing="md" aria-hidden="true" />
                </Button>
            </div>
        </div>
    );
};

export default memo(ActiveFilters);
